import { gql } from '@grandvisionhq/graphql';

/**
 * After the user has activated their social account, we receive from the BE possible mergeable accounts.
 * In that case we give the user the option to merge them or to keep them separated.
 *
 * This mutation will be used when the user choose to merge the primary account (non-social account) with the new social account.
 */ const REQUEST_SOCIAL_LOGIN_MERGE = gql`
  mutation requestSocialLoginMerge {
    # This is a void mutation
    requestSocialLoginMerge {
      failures {
        __typename
      }
    }
  }
`;

export { REQUEST_SOCIAL_LOGIN_MERGE };
//# sourceMappingURL=request-social-login-merge.js.map
